module.exports = __webpack_public_path__ + "static/media/folder-q-led_pl.d00a50db.pdf";